import { ErrorType, LoadedType, RequestType } from 'common/actions/helpscoutSettings';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
